<template>
  <div class="journey-media-container">
    <BrightcoveVideo v-if="media.type === 'video'" :id="media.video.ref" />
    <img
      role="presentation"
      v-else-if="media.type === 'image'"
      :src="media.image.src"
    />
  </div>
</template>

<script>
import BrightcoveVideo from "@/common/components/BrightcoveVideo";

export default {
  props: {
    media: {
      type: Object,
      required: false,
    },
  },
  components: {
    BrightcoveVideo,
  },
};
</script>

<style lang="less" scoped>
.journey-media-container {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  transition: box-shadow 0.3s ease-in-out;
  aspect-ratio: 16/9;
  overflow: hidden;
  background: #343434;
  margin-top: 1rem;
  margin-bottom: 1rem;
  border-radius: 0.5rem;


  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .videoplayer {
    width: 100%;
    height: 100%;
  }
}
</style>
